export function applyConfirmationLayoutClass(settings, hasExtrasellOffers) {
  const page = document.querySelector(".vg-confirmation-page");
  if (!page) {
    return;
  }

  const hasThankYouHtml =
    typeof settings?.richContent === "string" &&
    settings.richContent.trim().length > 0;
  const recapBottom =
    settings?.recapPosition === "bottom" &&
    (hasExtrasellOffers || hasThankYouHtml);
  page.classList.toggle("vg-confirmation-page--recap-bottom", recapBottom);
}
